import questionIcon from '@/assets/images/question.svg';
import styles from './SummaryRow.module.scss';

interface Props {
  label: string;
  value: string | React.ReactNode;
  discount?: boolean;
  onClick?: () => void;
  testId: string;
}

const SummaryRow = ({ discount, label, value, onClick, testId }: Props) => {
  return (
    <div className={`${styles.row} ${discount ? styles.discount : ''}`}>
      <h3>
        {label}
        {onClick && (
          <span className={styles.infoText} onClick={onClick}>
            <img src={questionIcon} alt="Info icon" />
          </span>
        )}
      </h3>
      <div data-testid={testId}>{value}</div>
    </div>
  );
};

export default SummaryRow;
